import { GradeConversionDetailsContextProvider } from './context/GradeConversionDetailsContext';
import { GradeConversionDetailsLayout } from './layouts';

export function GradeConversionDetailsPage() {
  return (
    <GradeConversionDetailsContextProvider>
      <GradeConversionDetailsLayout />
    </GradeConversionDetailsContextProvider>
  );
}
